import { AsyncPipe, DatePipe, NgIf, NgFor, CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSortModule, Sort } from '@angular/material/sort';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { EDocRow, EDocumentationService } from 'src/app/data/e-documentation-service';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-documents-table',
  standalone: true,
  imports: [
    CommonModule, MatTableModule, MatMenuModule, MatIconModule, MatButtonModule,
    MatPaginatorModule, MatSortModule, AsyncPipe, DatePipe, SharedModule
  ],
  templateUrl: './documents-table.component.html',
  styleUrls: ['./documents-table.component.scss']
})
export class DocumentsTableComponent {
  private svc = inject(EDocumentationService);

  displayedColumns = [
    'DocType', 'Title', 'ValidFrom', 'ValidTo', 'Signature', 'Version',
    'AddedBy', 'LastChanged', 'Actions'
  ];

  private sort$ = new BehaviorSubject<Sort>({ active: 'ValidFrom', direction: 'desc' });
  private page$ = new BehaviorSubject<{ pageIndex: number; pageSize: number }>({ pageIndex: 0, pageSize: 10 });

  readonly total$ = this.svc.total$;

  readonly dataSource$ = combineLatest([
    this.sort$, this.page$
  ]).pipe(
    // pobranie danych z backendu w Twoim stylu
    map(([sort, page]) => {
      this.svc.load({
        sortBy: sort.active,
        sortDir: sort.direction || 'asc',
        page: page.pageIndex + 1,
        pageSize: page.pageSize
      });
      return null;
    }),
    // stream właściwy z serwisu
    map(() => this.svc.rows$),
    // flatten, bo rows$ jest Subjectem
    // możesz to uprościć jeśli wolisz
  );

  constructor() {
    // od razu załaduj
    this.svc.load({ sortBy: 'ValidFrom', sortDir: 'desc', page: 1, pageSize: 10 });
  }

  onAddClick(): void {
    this.svc.addDocument();
  }

  openPreview(el: EDocRow): void {
    this.svc.preview(el);
  }

  download(el: EDocRow): void {
    this.svc.download(el);
  }

  editMetadata(el: EDocRow): void {
    this.svc.edit(el);
  }

  sign(el: EDocRow): void {
    this.svc.sign(el);
  }

  share(el: EDocRow): void {
    this.svc.share(el);
  }

  rowClick(row: EDocRow): void {
    this.openPreview(row);
  }

  onPage(e: PageEvent): void {
    this.page$.next({ pageIndex: e.pageIndex, pageSize: e.pageSize });
  }

  sortChange(e: Sort): void {
    if (e.direction === '') { e = { active: 'ValidFrom', direction: 'desc' }; }
    this.sort$.next(e);
  }
}
